<template bgcolor="#A0A0A0" vlink="blue" link="blue">
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful
        title="Credimóvil | Contrato Credito"
        :head="{
          'meta[charset]': { charset: 'utf-8' }
        }"
      />
      <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>
    </div>

    <section class="banner_area banner_area_1"></section>
    <div class="container center p-3">
      <button class="btn bg-success text-white" @click="generatePDF()">
        Generar PDF
      </button>
    </div>
    <!-- Banner Area -->
    <div ref="document">
      <div
        id="page1-div"
        class="container interline border page-container"
      >
        <div class="col-12">
          <div class="pt-lg-2">
            <div
              class="col-12 border border-dark text-center bg-dark rounded p-2 font-weight-bold"
            >
              <span class="ft13 text-white">
                Solicitud de Crédito del folio
                <span v-if="quote_credit.data.type_quote == 'Credito'">
                  CM
                </span>
                <span v-else>
                  Ar
                </span>
                {{ quote_credit.data.user_id }}
              </span>
            </div>
          </div>
          <div class="pt-lg-3">
            <div class="col-12 border border-gray  bg-muted rounded">
              <span class="h5 font-weight-bold">
                <br />Financiamiento personal <br /><br />
              </span>
              <span class="ft12Black ">
                Producto:
                <span class="ft12">
                  <!-- {{ quote_credit.data.user_id }} -->
                  <br /><br />
                  {{ quote_credit.data.type_quote }} <br /><br />
                </span>
              </span>
              <div class="col-12 row pt-1">
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Asesor:
                    <span class="ft12">
                      {{ userData.data.clave_asesor }} <br /><br />
                    </span>
                  </span>
                </div>

                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Monto a financiar:
                    <span class="ft12">
                      {{ quote_credit.data.requested_amount_credit }}
                      <br /><br />
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-12 row pt-1">
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Vehiculo:
                    <span class="ft12">
                      {{ quote_credit.data.vehicle_brand }},
                      {{ quote_credit.data.vehicle_model }},
                      {{ quote_credit.data.vehicle_version }}<br /><br />
                    </span>
                  </span>
                </div>

                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Plazo:
                    <span class="ft12">
                      {{ quote_credit.data.months }} <br /><br />
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-12 row pt-1">
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Fecha de inicio:
                    <span class="ft12">
                      {{ userData.data.created_at }}<br /><br />
                    </span>
                  </span>
                </div>

                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Precio del vehiculo:
                    <span class="ft12">
                      {{ quote_credit.data.vehicle_price }} <br /><br />
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-12 row pt-1">
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Días en trámite:
                    <span class="ft12">
                      {{ userData.data.dias }}<br /><br />
                    </span>
                  </span>
                </div>

                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Enganche:
                    <span class="ft12">
                      {{ quote_credit.data.vehicle_hitch }} <br /><br />
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-12 row pt-1">
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Compañia seguro:
                    <span class="ft12">
                      {{ insurceData.data.insurce_name }} <br /><br />
                    </span>
                  </span>
                </div>
                <div class="col-6 text-left">
                  <span class="ft12Black">
                    Precio seguro:
                    <span class="ft12">
                      {{ insurceData.data.insurce_price }} <br /><br />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="py-xl-4 col-12 border border-dark border">
            <br />
            <div
              class="col-12 border border-dark text-center bg-dark rounded p-2 font-weight-bold"
            >
              <span class="ft13 text-white">
                Resumen del Solicitante
              </span>
            </div>
            <span class="h5 font-weight-bold">
              <br />DATOS PERSONALES<br /><br />
            </span>
            <div class="border border-dark">
              <div class="col-12 p-1 m-0 row  bg-secondary ">
                <div class="col-2 text-center">
                  <span class="ft12 text-white">
                    *Nombre
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    *Apellido Paterno
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    *Apellido Materno
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft12 text-white">
                    * Fecha de nacimiento
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row ">
                <div class="col-2 text-center">
                  <span class="ft12">
                    {{ detailsData.data.first_name }}
                    {{ detailsData.data.last_name }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ detailsData.data.father_name }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ detailsData.data.mother_name }}
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft12">
                    {{ detailsData.data.DOB }}
                  </span>
                </div>
              </div>
              <div class="col-12 p-1 m-0 row  bg-secondary">
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    Verifica tu edad
                  </span>
                </div>
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Sexo
                  </span>
                </div>
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * País de nacimiento
                  </span>
                </div>
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Teléfono
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-3 text-center">
                  <span class="ft12">
                    {{ detailsData.data.edad }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ detailsData.data.gender }}
                  </span>
                </div>
                <div class="col-3 text-center">
                  <span class="ft12"> {{ detailsData.data.nacionality }} </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> {{ userData.data.phone }} </span>
                </div>
              </div>
              <div class="col-12 p-1 m-0 row  bg-secondary">
                <div class="col-2 text-center">
                  <span class="ft12 text-white">
                    * Celular
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Email
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * RFC
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft12 text-white">
                    CURP
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-2 text-center">
                  <span class="ft12">
                    {{ userData.data.phone }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ userData.data.email }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ detailsData.data.RFC }}
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft12">{{ detailsData.data.CURP }} </span>
                </div>
              </div>
            </div>
            <span class="h5 font-weight-bold">
              <br />DOMICILIO <br />
              <br />
            </span>
            <div class="border border-dark">
              <div class="col-12  p-1 m-0 row  bg-secondary">
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Calle
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Número exterior
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    Número interior
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Estado
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-3 text-center">
                  <span class="ft12">
                    {{ addressData.data.street }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ addressData.data.address_no }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"
                    >{{ addressData.data.address_inside_no }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ addressData.data.state }}
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row  bg-secondary">
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Delegación / Municipio
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Colonia
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * C.P.
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Entre calles
                  </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-3 text-center">
                  <span class="ft12">
                    {{ addressData.data.town }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ addressData.data.suburb }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ addressData.data.postcode }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row  bg-secondary">
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Tipo de vivienda
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * Años de residencia
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white"> </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white"> </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-3 text-center">
                  <span class="ft12">
                    {{ addressData.data.current_living }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ addressData.data.living_since }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> </span>
                </div>
              </div>
            </div>
            <span class="h5 font-weight-bold">
              <br />DATOS FAMILIARES <br />
              <br />
            </span>
            <div class="border border-dark">
              <div class="col-12  p-1 m-0 row  bg-secondary">
                <div class="col-3 text-center">
                  <span class="ft12 text-white">
                    * Estado civil
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12 text-white">
                    * No. de hijos
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft12 text-white">
                    * Dependientes económicos
                  </span>
                </div>
                <div class="col-1  text-center">
                  <span class="ft12 text-white"> </span>
                </div>
              </div>
              <div class="col-12  p-1 m-0 row">
                <div class="col-3 text-center">
                  <span class="ft12">
                    {{ detailsData.data.marital_status }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12">
                    {{ detailsData.data.economic_dependents }}
                  </span>
                </div>
                <div class="col-3  text-center">
                  <span class="ft12"> </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="page2-div"
        class="container interline border page-container"
      >
        <div class="col-12 ">
          <div class="pt-lg-3">
            <div class="col-12 border border-dark">
              <span class="h5 font-weight-bold">
                <br />
                REFERENCIAS<br /><br />
              </span>

              <div class="border border-dark rounded">
                <div class="col-12 row pt-lg-3 ">
                  <div class="col-1 text-center border border-gray rounded">
                    <span class="ft12">
                      <br />
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      REFERENCIA PERSONAL
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-4 text-center">
                    <span class="ft12 text-white">
                      * Tipo de Referencia
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * Nombre(s) </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * telefono </span>
                  </div>
                </div>
                <div class="col-12 p-1 m-1 row">
                  <div class="col-4 text-center">
                    <span class="ft12 ">{{ referenceData.data.type }}</span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data.name }} </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data.phone }} </span>
                  </div>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div class="border border-dark rounded">
                <div class="col-12 row pt-lg-3 ">
                  <div class="col-1 text-center border border-gray rounded">
                    <span class="ft12">
                      <br />
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      REFERENCIA PERSONAL
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-4 text-center">
                    <span class="ft12 text-white">
                      * Tipo de Referencia
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * Nombre(s) </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * telefono </span>
                  </div>
                </div>
                <div class="col-12 p-1 m-1 row">
                  <div class="col-4 text-center">
                    <span class="ft12 ">{{ referenceData.data2.type }}</span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data2.name }} </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data2.phone }} </span>
                  </div>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div class="border border-dark rounded">
                <div class="col-12 row pt-lg-3 ">
                  <div class="col-1 text-center border border-gray rounded">
                    <span class="ft12">
                      <br />
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      REFERENCIA PERSONAL
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-4 text-center">
                    <span class="ft12 text-white">
                      * Tipo de Referencia
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * Nombre(s) </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> * telefono </span>
                  </div>
                </div>
                <div class="col-12 p-1 m-1 row">
                  <div class="col-4 text-center">
                    <span class="ft12 ">{{ referenceData.data1.type }}</span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data1.name }} </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 "> {{ referenceData.data1.phone }} </span>
                  </div>
                </div>
                <div>
                  <br />
                </div>
              </div>
              <div>
                <br />
              </div>
              <span class="h5 font-weight-bold">
                <br />
                Empleos
                <br />
                <br />
              </span>
              <div class="border border-dark  rounded">
                <div class="col-12 ft12 ">
                  <br />INFORMACIÓN FINANCIERA Y LABORAL <br />
                  <br />
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-3 text-center">
                    <span class="ft12 text-white">
                      * Ingresos mensuales netos
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12 text-white">
                      Ingresos comprobables
                    </span>
                  </div>
                  <div class="col-6  text-center">
                    <span class="ft12 text-white">
                      Otros ingreso
                    </span>
                  </div>
                </div>
                <div class="col-12 row pt-2">
                  <div class="col-4 text-center">
                    <span class="ft12">
                      {{ employmentData.data.net_income }}
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      {{ employmentData.data.verifiable_income }}</span
                    >
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12"
                      >{{ employmentData.data.unverifiable_income }}
                    </span>
                  </div>
                </div>
                <div class="col-12 ft12">
                  <br />INFORMACIÓN LABORAL <br />
                  <br />
                </div>

                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-3 text-center">
                    <span class="ft12 text-white">
                      * Situación laboral
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                  <div class="col-6  text-center">
                    <span class="ft12"> </span>
                  </div>
                </div>
                <div class="col-12 row pt-2">
                  <div class="col-3 text-center">
                    <span class="ft12">
                      {{ employmentData.data.employment_situation }}
                    </span>
                  </div>
                  <div class="col-3  text-center">
                    <span class="ft12"> </span>
                  </div>
                  <div class="col-6  text-center">
                    <span class="ft12"> </span>
                  </div>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div class="border border-dark rounded">
                <div class="col-12 row pt-lg-3 ">
                  <div class="col-12">
                    EMPLEO ACTUAL/ÚLTIMO
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-4 text-center">
                    <span class="ft12 text-white">
                      * Nombre de la empresa
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white"> Actividad económica </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12 text-white">Ocupación</span>
                  </div>
                </div>
                <div class="col-12 p-1 m-0 row ">
                  <div class="col-4 text-center">
                    <span class="ft12">
                      {{ employmentData.data.company_name }}
                    </span>
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      {{ employmentData.data.line_of_business }}</span
                    >
                  </div>
                  <div class="col-4  text-center">
                    <span class="ft12">
                      {{ employmentData.data.ocupation }}</span
                    >
                  </div>
                </div>
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-6 text-center">
                    <span class="ft12 text-white">
                      * Situación laboral
                    </span>
                  </div>
                  <div class="col-6  text-center">
                    <span class="ft12 text-white">
                      * Antigüedad en este empleo
                    </span>
                  </div>
                </div>
                <div class="col-12 p-1 m-0 row">
                  <div class="col-6 text-center">
                    <span class="ft12"
                      >{{ employmentData.data.employment_situation }}
                    </span>
                  </div>
                  <div class="col-6  text-center">
                    <span class="ft12">
                      {{ employmentData.data.workplace }}6</span
                    >
                  </div>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div class="col-12 border border-dark ">
                <div class="col-12 p-1 m-0 row  bg-secondary">
                  <div class="col-12 text-center">
                    <span class="h4 text-white">
                      * Comentario del cliente
                    </span>
                  </div>
                </div>
                <div class="col-12 p-2 m-0 row">
                  <div class="col-12 text-center p-3">
                    <span class="ft12 ">
                      {{ detailsData.data.comment }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
export default {
  name: "pdfGrayZone",
  data() {
    return {
      userData: {
        data: {
          email: "",
          phone: "",
          created_at: "",
          clave_asesor: ""
        }
      },
      employmentData: {
        data: {
          employment_situation: "fixed",
          antique: "1",
          ocupation: "",
          vacation_per_year: 0,
          education: 0,
          line_of_business: "",
          company_name: "",
          workplace: "",
          net_income: "",
          verifiable_income: "",
          unverifiable_income: ""
        }
      },
      quote_credit: {
        data: {
          user_id: "",
          vehicle_model: "",
          vehicle_brand: "",
          vehicle_version: "2020",
          vehicle_description: "",
          purpose_of_vehicle: "",
          vehicle_type: "",
          requested_amount_credit: "",
          months: "",
          vehicle_price: "",
          vehicle_hitch: "",
          insurance_payment: ""
        }
      },
      detailsData: {
        data: {
          marital_status: "",
          RFC: "",
          gender: "",
          mother_name: "",
          father_name: "",
          first_name: "",
          last_name: "",
          DOB: "",
          nacionality: "",
          CURP: "",
          edad: ""
        }
      },
      AnalystData: {
        data: {
          Nombre: ""
        }
      },
      insurceData: {
        data: {
          insurce_name: "",
          insurce_price: ""
        }
      },
      addressData: {
        data: {
          current_living: "0",
          living_since: "0",
          monthly_rent: "0",
          street: "",
          address_no: "",
          address_inside_no: "",
          state: "",
          town: "",
          suburb: "",
          postcode: ""
        }
      },
      referenceData: {
        data: {
          name: "",
          phone: "",
          type: ""
        },
        data1: {
          name: "",
          phone: "",
          type: ""
        },
        data2: {
          name: "",
          phone: "",
          type: ""
        }
      }
    };
  },
  validations() {
    return {};
  },

  methods: {
    generatePDF() {
      this.preloader();
      html2pdf(this.$refs.document, {
        margin: 0,
        filename:
          this.detailsData.data.first_name +
          "_" +
          this.detailsData.data.father_name +
          "_PERFIL.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 1,
          letterRendering: true,
          useCORS: true,
          imageTimeout: 0
        },
        jsPDF: { unit: "mm", format: "A4", orientation: "p" }
      });
      this.preloaderHiden();
    },
    getLastYears() {
      var year = new Date().getFullYear();
      for (let index = 0; index < 11; index++) {
        this.lastYears.push(year - index);
      }
    },
    getUser() {
      this.$UserService.getUser().then(result => {
        if (result.data.length > 0) {
          let created_at = moment(result.data[0].created_at);
          let dateNow = moment();
          this.userData.data.email = result.data[0].email;
          this.userData.data.phone = result.data[0].phone;
          this.userData.data.clave_asesor = result.data[0].clave_asesor;

          this.userData.data.created_at = created_at;
          this.userData.data.dias = dateNow.diff(created_at, "days");
        }
      });
    },
    getInsurce() {
      this.$InsuranceService.getInsurce().then(result => {
        if (result.data.length > 0) {
          this.insurceData.data.insurce_name = result.data[0].insurce_name;
          this.insurceData.data.insurce_price = result.data[0].insurce_price;
        }
      });
    },
    getEmployement() {
      this.$UserService.getEmployement().then(result => {
        if (result.data.length > 0) {
          this.employmentData.data.employment_situation =
            result.data[0].employment_situation;
          this.employmentData.data.line_of_business =
            result.data[0].line_of_business;
          this.employmentData.data.ocupation = result.data[0].ocupation;
          this.employmentData.data.education = result.data[0].education;
          this.employmentData.data.antique = result.data[0].antique;
          this.employmentData.data.company_name = result.data[0].company_name;
          this.employmentData.data.workplace = result.data[0].workplace;
          this.employmentData.data.net_income = result.data[0].net_income;
          this.employmentData.data.verifiable_income =
            result.data[0].verifiable_income;
          this.employmentData.data.unverifiable_income =
            result.data[0].unverifiable_income + result.data[0].family_income;
        }
      });
    },
    getQuoteCredit() {
      this.$UserService.getCreditQuotation().then(result => {
        if (result.data.length > 0) {
          this.quote_credit.data.vehicle_brand = result.data[0].vehicle_brand;
          this.quote_credit.data.vehicle_model = result.data[0].vehicle_model;
          this.quote_credit.data.vehicle_version =
            result.data[0].vehicle_version;
          this.quote_credit.data.purpose_of_vehicle =
            result.data[0].purpose_of_vehicle;
          this.quote_credit.data.insurance_payment =
            result.data[0].insurance_payment;
          this.quote_credit.data.user_id = result.data[0].user_id;
          this.quote_credit.data.months = result.data[0].months;
          this.quote_credit.data.requested_amount_credit =
            result.data[0].requested_amount_credit;
          this.quote_credit.data.vehicle_price = result.data[0].vehicle_price;
          this.quote_credit.data.vehicle_hitch = result.data[0].vehicle_hitch;
          this.quote_credit.data.insurance_payment =
            result.data[0].insurance_payment;
        }
      });
    },
    getDetails() {
      this.$UserService.getDetails().then(result => {
        if (result.data.length > 0) {
          let DOB = moment(result.data[0].DOB);
          let dateNow = moment();
          this.detailsData.data.marital_status = result.data[0].marital_status;
          this.detailsData.data.were_clients = result.data[0].were_clients;
          this.detailsData.data.economic_dependents =
            result.data[0].economic_dependents;
          this.detailsData.data.RFC = result.data[0].RFC;
          this.detailsData.data.gender = result.data[0].gender;
          this.detailsData.data.edad = dateNow.diff(DOB, "years");
          this.detailsData.data.mother_name = result.data[0].mother_name;
          this.detailsData.data.father_name = result.data[0].father_name;
          this.detailsData.data.first_name = result.data[0].first_name;
          this.detailsData.data.last_name = result.data[0].last_name;
          this.detailsData.data.DOB = result.data[0].DOB;
          this.detailsData.data.nacionality = result.data[0].nacionality;
          this.detailsData.data.CURP = result.data[0].CURP;
          this.detailsData.data.comment = result.data[0].comment;
        }
      });
    },
    getAddress() {
      this.$UserService.getAddress().then(result => {
        if (result.data.length > 0) {
          this.addressData.data.current_living = result.data[0].current_living;
          this.addressData.data.living_since = result.data[0].living_since;
          this.addressData.data.monthly_rent = result.data[0].monthly_rent;
          this.addressData.data.street = result.data[0].street;
          this.addressData.data.address_no = result.data[0].address_no;
          this.addressData.data.address_inside_no =
            result.data[0].address_inside_no;
          this.addressData.data.state = result.data[0].state;
          this.addressData.data.town = result.data[0].town;
          this.addressData.data.suburb = result.data[0].suburb;
          this.addressData.data.postcode = result.data[0].postcode;
        }
      });
    },
    getReference() {
      this.$UserService.getReference().then(
        result => {
          if (result.data.length > 0) {
            this.referenceData.data1.name = result.data[0].name;
            this.referenceData.data1.phone = result.data[0].phone;
            this.referenceData.data1.type = result.data[0].type;
          }
          if (result.data.length >= 2) {
            this.referenceData.data2.name = result.data[1].name;
            this.referenceData.data2.phone = result.data[1].phone;
            this.referenceData.data2.type = result.data[1].type;
          }
          if (result.data.length >= 3) {
            this.referenceData.data.name = result.data[2].name;
            this.referenceData.data.phone = result.data[2].phone;
            this.referenceData.data.type = result.data[2].type;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },

    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  components: {},
  created() {
    this.$UserService.updateFromTaskClickUp().then(
      result => {
        console.log("--------updateFromTaskClickUp---------");
        this.preloader();
        this.getInsurce();
        this.getEmployement();
        this.getUser();
        this.getQuoteCredit();
        this.getDetails();
        this.getAddress();
        this.getReference();
        window.scrollTo(0, 0);
        this.preloaderHiden();
      },
      err => {
        console.log("--error------updateFromTaskClickUp---------");
        console.log(err);
        this.$swal("CUIDADO!", err.msg, "error");
        this.preloaderHiden();
      }
    );
  }
};
</script>
<style type="text/css">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/GrayZone/pdfGrayZone.vue